// src/components/layout/Layout.js
import React, { useEffect,useState } from 'react';
import { Outlet } from 'react-router-dom';
// Removed Container, Row, Col from here - handled by CSS/Wrapper divs
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { useTranslation } from 'react-i18next';

const Layout = () => {
  const { i18n } = useTranslation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true); // Default to open
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Close sidebar if clicking overlay on mobile
  const handleOverlayClick = () => {
      if (isMobile && isSidebarOpen) {
          setIsSidebarOpen(false);
      }
  }
// Update mobile state on resize
useEffect(() => {
  const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
       // Optional: Automatically close sidebar if resizing from mobile to desktop while open?
      // if (window.innerWidth >= 768 && isSidebarOpen && isMobile) {
      //     setIsSidebarOpen(false); // Close if transitioning from mobile overlay state
      // }
       // Optional: Ensure sidebar is open on desktop by default if resizing up?
       // if(window.innerWidth >= 768 && !isSidebarOpen) {
       //    setIsSidebarOpen(true);
       //}
  };

  window.addEventListener('resize', handleResize);
  // Initial check
  handleResize();

  return () => window.removeEventListener('resize', handleResize);
}, []); // Run only once on mount/unmount
  useEffect(() => {
    const currentLanguage = i18n.language;
    document.body.dir = currentLanguage === 'ar' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  return (
    <div className="app-container"> {/* Use flex container */}
        {/* Sidebar (conditionally rendered for mobile needed for true offcanvas) */}
        {/* For now, CSS hides it on smaller screens */}
        <div className={`sidebar-wrapper ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            <Sidebar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} /> {/* Pass toggle function if Sidebar needs internal close button */}
        </div>

        {/* Main Content Area */}
        <div  className={`main-content-wrapper ${isSidebarOpen && !isMobile ? 'main-content-open' : 'main-content-closed'}`}>
            <Header toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} /> {/* Header component */}
            <main className="page-content"> {/* Added main tag with padding */}
                <Outlet /> {/* Child routes will render here */}
            </main>
            <Footer />
        </div>
        {/* Mobile Overlay */}
        <div
            className={`mobile-overlay ${isMobile && isSidebarOpen ? 'overlay-visible' : ''}`}
            onClick={handleOverlayClick}
        ></div>
    </div>
  );
};

export default Layout;